<template>
    <div>
        <transition name="slide-home">
            <div v-show="showOverview" class="home">
                <div class="row">
                    <div class="col-12">
                        <div class="btn-toolbar border-hr border-bottom mb-3 pb-3 d-flex justify-content-between align-items-center">
                            <div class="d-flex justify-content-start">
                                <div class="input-group search-bar mr-3">
                                    <input data-hj-whitelist class="form-control" v-model="q" placeholder="Zoeken" type="search" aria-label="Search" @input="checkReset" @keyup.enter="searchQ(true)">

                                    <div class="input-group-append">
										<button @click="searchQ(true)" class="btn btn-light" type="submit"><i class="fas fa-search"></i></button>
										<button @click="searchQ()" class="btn btn-light" type="submit"><i class="fas fa-filter"></i></button>
                                    </div>
                                </div>

                                <div class="btn-group">
                                    <checked-filter :data="formResponse ? formResponse.filters.sources : []" :searchbar="true" faIcon="fas fa-globe-americas" placeholder="Bronnen" v-model="filters.sources"></checked-filter>
                                    <checked-filter :data="formResponse ? formResponse.filters.statuses : []" :searchbar="false" faIcon="fas fa-tag" placeholder="Status" v-model="filters.statuses"></checked-filter>
                                    <checked-filter :data="formResponse ? formResponse.filters.assignees : []" :searchbar="true" faIcon="fas fa-user" placeholder="Toegewezen aan" v-model="filters.assignees"></checked-filter>
                                </div>
                            </div>

                            <div class="text-muted text-right">
                                <small>Sorteer op: </small>
                                <select class="custom-select" style="width: 150px;" v-model="sorting">
                                    <option v-for="sort in sortable" :value="sort">{{ sort.label }}</option>
                                </select>

                                <router-link :to="{name:'lead.create'}" class="btn btn-primary"><i class="fas fa-plus"></i> Nieuwe lead</router-link>
                                <router-link :to="{name:'nv-lead.create'}" class="btn btn-dark"><i class="fas fa-plus"></i> Nieuwe NV-lead</router-link>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="active-filters">
                    <filter-list :showDisabled="skipFilters" faIcon="fas fa-tag" placeholder="Status" v-model="filters.statuses"></filter-list>
                    <filter-list :showDisabled="skipFilters" faIcon="fas fa-globe-americas" placeholder="Bron" v-model="filters.sources"></filter-list>
                    <filter-list :showDisabled="skipFilters" faIcon="fas fa-user" placeholder="Toegewezen aan" v-model="filters.assignees"></filter-list>
                </div>

                <div class="alert alert-danger mb-4" v-if="errors.length > 0">
                    <p class="mb-0">Er is iets fout gegaan:</p>
                    <br>
                    <ul>
                        <li v-for="error in errors">
                            {{ error }}
                        </li>
                    </ul>
                </div>

                <div class="row mt-3">
                    <div class="col-md-8">
                        <i class="fas fa-level-down-alt fa-rotate-270 fa-lg text-muted ml-4"></i>

                        <!--<button class="btn btn-light btn-sm ml-2 mt-0 mb-2" @click="assign()" :disabled="selected.length===0">
                            Toewijzen
                        </button>

                        <button class="btn btn-light btn-sm ml-1 mb-2" @click="readStateUpdate('unread')" :disabled="selected.length===0">
                            Ongelezen
                        </button>-->

                        <button class="btn btn-light btn-sm text-danger ml-1 mb-2" @click="remove('spam')" :disabled="selected.length===0">
                            <i class="fas fa-ban"></i> Spam
                        </button>
                    </div>

                    <div class="col-md-4 text-right">
                        <small class="text-muted pr-2">
                            {{ formResponse ? (formResponse.to > 0) ? formResponse.to - formResponse.from + 1 : formResponse.to - formResponse.from : '0' }}
                            van
                            {{ formResponse ? formResponse.total : '?' }} resultaten

                            <a class="text-primary refresh force m-1" @click="refresh()">
                                <em class="fa fa-sync" :class="{'fa-spin': loaded===null || !loaded}"></em>
                            </a>
                        </small>
                    </div>
                </div>

                <div class="placeholder" :class="{'whirl ringed': !loaded}">
                    <div class="leads list-group list-group-sm" v-if="errors.length === 0 &&formResponse !== null">
                        <div class="list-group-item d-flex justify-content-between align-items-center leads-header">
                            <div class="t t-tool">
                                <b-form-checkbox data-hj-whitelist v-model="selectAll"></b-form-checkbox>
                            </div>
                            <div class="t t-id">
                                <div class="data">
                                    <strong>#</strong>
                                </div>
                            </div>
                            <div class="t t-status">
                                <div class="data">
                                    <strong>Status:</strong>
                                </div>
                            </div>
                            <div class="t t-source">
                                <div class="data">
                                    <strong>Bron:</strong>
                                </div>
                            </div>
                            <div class="t t-form">
                                <div class="data">
                                    <strong>Titel:</strong>
                                </div>
                            </div>
                            <div class="t t-email">
                                <div class="data">
                                    <strong>E-mailadres:</strong>
                                </div>
                            </div>
                            <div class="t t-created">
                                <div class="data">
                                    <strong>Ontvangen op:</strong>
                                </div>
                            </div>
                            <div class="t t-assignee">
                                <div class="data">
                                    <strong>Toegewezen aan:</strong>
                                </div>
                            </div>
                        </div>

                        <div v-if="formResponse.to === null && onlyFilteredOpen">
                            <div class="not-found list-group-item d-flex justify-content-center align-items-center flex-column p-5">
                                <i class="fas fa-grin-beam text-muted fa-3x m-3"></i>
                                <span class="my-2">Alle leads zijn verwerkt!</span>
                                <span class="my-2 mb-3">Pas de filters aan om afgehandelde leads te bekijken.</span>
                            </div>
                        </div>
                        <div v-else-if="formResponse.to === null">
                            <div class="not-found list-group-item d-flex justify-content-center align-items-center flex-column p-5">
                                <i class="fas fa-scroll text-muted fa-3x m-3"></i>
                                <span class="my-2">Geen leads gevonden voor de ingestelde filters.</span>
                                <span class="my-2 mb-3">Pas de filters aan en probeer het opnieuw:</span>

                                <div class="active-filters">
                                    <filter-list :showDisabled="skipFilters" placeholder="Status" v-model="filters.statuses"></filter-list>
                                    <filter-list :showDisabled="skipFilters" placeholder="Bron" v-model="filters.sources"></filter-list>
                                    <filter-list :showDisabled="skipFilters" placeholder="Toegewezen aan" v-model="filters.assignees"></filter-list>
                                </div>
                            </div>
                        </div>

                        <lead-row v-for="(form, index) in formResponse.data" :key="'form-details-' + form.id"  :lead="form" v-model="selected" @updated="updatedLead"></lead-row>

                        <div class="list-group-item d-flex justify-content-between align-items-center leads-header">
                            <div class="t t-tool">
                                <b-form-checkbox data-hj-whitelist v-model="selectAll"></b-form-checkbox>
                            </div>
                            <div class="t t-id">
                                <div class="data">
                                    <strong>#</strong>
                                </div>
                            </div>
                            <div class="t t-status">
                                <div class="data">
                                    <strong>Status:</strong>
                                </div>
                            </div>
                            <div class="t t-source">
                                <div class="data">
                                    <strong>Bron:</strong>
                                </div>
                            </div>
                            <div class="t t-form">
                                <div class="data">
                                    <strong>Titel:</strong>
                                </div>
                            </div>
                            <div class="t t-email">
                                <div class="data">
                                    <strong>E-mailadres:</strong>
                                </div>
                            </div>
                            <div class="t t-created">
                                <div class="data">
                                    <strong>Ontvangen op:</strong>
                                </div>
                            </div>
                            <div class="t t-assignee">
                                <div class="data">
                                    <strong>Toegewezen aan:</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="clearfix"></div>

                <div class="mb-4">
                    <i class="fas fa-level-up-alt fa-rotate-90 fa-lg text-muted ml-4"></i>

                    <button class="btn btn-light btn-sm text-danger ml-2 mt-2" @click="remove('spam')" :disabled="selected.length===0">
                        <i class="fas fa-ban"></i> Spam
                    </button>
                </div>

                <pagination class="justify-content-center mb-4" v-if="formResponse!==null" :limit="10" :data="formResponse" @pagination-change-page="getForms">
                    <span slot="prev-nav"><em class="fa fa-arrow-left"></em></span>
                    <span slot="next-nav"><em class="fa fa-arrow-right"></em></span>
                </pagination>
            </div>
        </transition>
        <transition name="slide">
            <div v-show="!showOverview" class="detail-view" :class="{'whirl ringed': !loaded, 'position-right': !showOverview}">
                <router-view :forms="leads" @updated="updatedLead" @formDeleted="formDeleted"></router-view>
            </div>
        </transition>

        <app-footer></app-footer>
    </div>
</template>

<script>
    import CheckedFilter from './../helpers/checkedFilter';
    import FilterList from './../helpers/filterList';
    import LeadRow from "./leads/leadRow";
    import Assignee from "./leads/assignee";
    import appFooter from "./appFooter.vue";
    import { EventBus } from './../helpers/event-bus.js';

    export default {
        components: {
            LeadRow,
            CheckedFilter,
            FilterList,
            Assignee,
            appFooter
        },
        data() {
            return {
                transitionName: 'slide-left',
                selectAll: false,
                selected: [],
                selectIgnore: false,

                formResponse: null,
                sortable: [
                    {
                        label: 'Nieuwste eerst',
                        value: 'created_at',
                        direction: 'desc'
                    },
                    {
                        label: 'Oudste eerst',
                        value: 'created_at',
                        direction: 'asc'
                    },
                    {
                        label: 'Laatst bijgewerkt',
                        value: 'updated_at',
                        direction: 'desc'
                    }
                ],
                filters: {
                    sources: [],
                    statuses: []
                },
                q: '',
				skipFilters: false,
                page: 1,
                loaded: null,
                errors: [],
                showing: null,
                prevent: false
            }
        },
        computed: {
            showOverview() {
              return this.$route.name === 'home';
            },
            leads() {
              if(this.formResponse && this.formResponse.hasOwnProperty('data')) {
                   return this.formResponse.data;
              }
              return [];
            },
            sorting:{
                get: function () {
                    return this.$store.getters['sortingStore/sorting']({
                        label: 'Nieuwste eerst',
                        value: 'created_at',
                        direction: 'desc'
                    });
                },
                set: function (newValue) {
                    this.$store.commit('sortingStore/sorting', newValue);
                }
            },
            onlyFilteredOpen() {
                return (
                    this.filters.statuses
                    && this.filters.statuses.length === 1
                    && this.filters.statuses[0].value === 1
                    && (!this.q || this.q === '')
                    && (!this.filters.assignees || this.filters.assignees.length === 0)
                    && (!this.filters.sources || this.filters.sources.length === 0)
                )
            }
        },
        watch: {
            sorting() {
                this.getForms(this.page);
            },
            showing(val) {
              if(val !== null) {
                  this.opened(val, this.formResponse.data[val]);
              }
            },
            selectAll() {
                if(this.selectIgnore) {
                    this.selectIgnore = false;
                }
                else if(this.selectAll) {
                    let ids = [];
                    for(let i in this.formResponse.data) {
                        if(!this.formResponse.data.hasOwnProperty(i)) {
                            return
                        }

                        let f = this.formResponse.data[i];
                        if(f.finished_at === null) {
                            ids.push(f.id);
                        }
                    }
                    this.selected = ids;
                } else {
                    this.selected = [];
                }
            },
            selected() {
                if(this.loaded !== null) {
                    let changeSelectAllTo = (this.selected.length === this.formResponse.data.length);
                    if(changeSelectAllTo !== this.selectAll) {
                        this.selectIgnore = true;
                        this.selectAll = (this.selected.length === this.formResponse.data.length);
                    }
                }
            },
            filters: {
                handler(val){
                    if(!this.prevent) {
                        this.getForms(1);
                    } else {
                        this.prevent = false;
                    }
                },
                deep: true
            }
        },
        mounted() {
            this.getForms(this.page);
            EventBus.$on('refresh-list', this.refresh);
        },
        destroyed() {
            EventBus.$off('refresh-list', this.refresh);
        },
        methods: {
            finishedDetails(formSaved) {
                this.formResponse.data[this.showing] = formSaved;
                this.showing++;
            },

            elementInViewport(element) {
                let rect = element.getBoundingClientRect();
                let html = document.documentElement;
                return (
                    rect.top >= 0 &&
                    rect.left >= 0 &&
                    rect.bottom <= (window.innerHeight || html.clientHeight) &&
                    rect.right <= (window.innerWidth || html.clientWidth)
                );
            },

            getForms(page, skipFilters = false) {
				this.skipFilters = skipFilters;
                this.showing = null;
                this.loaded = null;
                this.errors = [];
                this.selected = [];
                this.selectAll = false;
                window.smoothScrollTo(0, 0, 800);
                axios.get('/api/v1/leads/form', {
                    params: {
                        sort: this.sorting.value,
                        dir: this.sorting.direction,
                        page: page,
                        sources: Array.isArray(this.filters.sources) ? this.filters.sources.map(a => a.value) : null,
                        statuses: Array.isArray(this.filters.statuses) ? this.filters.statuses.map(a => a.value) : null,
                        assignees: Array.isArray(this.filters.assignees) ? this.filters.assignees.map(a => a.value) : null,
						skipFilters: this.skipFilters,
                        q: this.filters.q
                    }
                }).then(response => {
                    this.loaded = new Date();
                    this.formResponse = response.data;
                    if(this.filters.statuses.length === 0) {
                        this.prevent = true;
                        this.filters.statuses.push(this.formResponse.filters.statuses[0]);
                    }
                })
                .catch(error => {
                    this.loaded = new Date();
                    if (error && typeof error.response.data === 'object') {
                        if(error.response.data.errors) {
                            this.errors = _.flatten(_.toArray(error.response.data.errors));
                        } else {
                            this.errors = [error.toString()];
                        }
                    } else {
                        this.errors = ['Something went wrong. Please try again.'];
                    }
                });
            },
            refresh() {
                this.getForms(this.page);
            },

            formDeleted(id) {
                if(!this.formResponse) {
                    return;
                }
                for(let index in this.formResponse.data) {
                    if (!this.formResponse.data.hasOwnProperty(index)) {
                        continue;
                    }

                    let lead = this.formResponse.data[index];

                    if (lead.id === id) {
                        this.formResponse.data.splice(index, 1);
                    }
                }
            },

            remove(reason = 'manual') {
                let mes = 'Alle '+ this.selected.length +' formulieren verwijderen?';
                let but = 'Verwijderen';
                if(reason === 'spam') {
                    mes = 'Alle '+ this.selected.length +' formulieren markeren als spam en verwijderen?';
                    let but = 'Markeren als spam en verwijderen';
                }
                this.$swal({
                    title: mes,
                    text: "Hiermee worden deze leads pernament verwijderd.",
                    type: 'warning',
                    showCancelButton: true,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-outline-danger',
                    cancelButtonClass: 'btn btn-outline-secondary mr-3',
                    confirmButtonText: but,
                    reverseButtons: true,
                    focusConfirm: false,
                    focusCancel: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        this.$swal.showLoading();
                        return axios.delete('/api/v1/leads/forms?reason=' + reason, {data: {forms: this.selected.join(',')}})
                            .then(response => {
                                return response.status;
                            })
                            .catch(error => {
                                this.$swal({
                                    type: 'error',
                                    showConfirmButton: false,
                                    html: this.$errorMessage(error)
                                });
                            });
                        return 200;
                    }
                }).then((result) => {
                    if (result.value) {
                        this.$swal(
                            'Verwijderd!',
                            'De leads zijn verwijderd',
                            'success'
                        ).then((result) => {
                            this.refresh();
                        })
                    }
                })
            },
            readStateUpdate(state) {
                this.refresh();
            },
            assign() {
                this.$refs.assigneeInput.show();
            },
            searchQ(skipFilters = false) {
				document.activeElement && document.activeElement.blur();
				this.filters.q = this.q;
				this.getForms(1, skipFilters);
            },
			checkReset(val) {
				if(val.target.value === '') {
					this.searchQ();
				}
			},
            updatedLead(data) {
                if(!this.formResponse) {
                    return;
                }
                for(let index in this.formResponse.data) {
                    if(!this.formResponse.data.hasOwnProperty(index)) {
                        continue;
                    }

                    let lead = this.formResponse.data[index];

                    if(lead.id === data.id) {
                        Vue.set(this.formResponse.data, index, data);
                    }
                }
            }
        }
    }
</script>

<style lang="scss">
    .action-link, .pointer {
        cursor: pointer;
    }
    .list-group-item-unread {
        font-weight: bold;
    }
    a.list-group-item {
        box-shadow: 0 1px 2px rgba(0,0,0,0.25);
    }
    a.list-group-item-finished {
        background: #f3f7f1 !important;
        box-shadow: none;
        &:hover {
            background: #e8ebe6 !important;
        }
    }
    a.refresh {
        &:hover {
             text-decoration: underline;
         }
    }
    em.fa {
        -webkit-transition: transform 200ms linear;
        -ms-transition: transform 200ms linear;
        transition: transform 200ms linear;
    }
    .details-open em.toggle.fa {
        transform: rotate(180deg);
    }
    a.details-bar {
        color: #212529 !important;
        &:hover {
            text-decoration: none !important;
        }
    }
    .details {
        background-color: #ffffff;
        margin-bottom: 12px;
        min-height: 500px;
    }
    .slide-fade-enter-active {
        transform: translate(0, 100%);
    }
    .slide-fade-leave-active {
        transform: translate(0, -100%);
    }
    .slide-fade-enter, .slide-fade-leave-to {
        height: 0;
        min-height: 0;
        opacity: 0.5;
        transition: .2s;
    }
    .source {
        box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        .dot {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            display: inline-block;
            margin-right: 3px;
        }
    }
    .search-bar {
        max-width: 500px;
    }

	.search-bar .btn-light:focus, .btn-light.focus {
		outline: none;
		box-shadow: none;
	}

	.search-bar input::-webkit-search-cancel-button {
		-webkit-appearance: none;
		height: 16px;
		width: 16px;
		margin-right: 0;
		background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23777'><path d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'/></svg>");
		cursor: pointer;
	}

    @media (max-width: 768px) {
        .list-group-sm {
            font-size: 0.8em;
        }
    }
    .slide-leave-active,
    .slide-enter-active,
    .slide-home-leave-active,
    .slide-home-enter-active {
        transition: .2s;
    }
    .slide-enter {
        transform: translate(150%, 0);
        opacity: 1;
        position: absolute;
    }
    .slide-leave-to {
        transform: translate(-150%, 0);
        opacity: 0;
        position: absolute;
    }
    .slide-home-enter {
        transform: translate(-150%, 0);
        opacity: 1;
    }
    .slide-home-leave-to {
        transform: translate(-150%, 0);
        opacity: 0;
    }
    body {
        overflow-x: hidden;
    }
    .detail-view {
        &.slide-enter,
        &.slide-enter-active {
            float: right;
            position: absolute;
            top: 0;
            margin-left: 16px;
            width: 100%;
            max-width: 2800px;
        }
    }

    .position-right {
        float: right;
        top: 0;
        width: 100%;
        max-width: 2800px;
    }

    .leads {
        .lead-row {
            padding: 0 8px;
        }
        .prevented {
            cursor: default;
        }
        .t {
            overflow: hidden;
            padding: 0.75rem 8px;
            align-items: center;
            display: flex;

            .data {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
        .t-tool {
            width: 2.2%;
        }
        .t-id {
            width: 7%;
        }
        .t-status {
            width: 13.6%;
        }
        .t-source{
            width: 17%;
            .data {
                height: 100%;
                align-items: center;
                display: flex;
                padding: 0 3px;
            }
        }
        .t-form{
            width: 18%;
        }
        .t-email{
            width: 17%;
        }
        .t-created{
            width: 8%;
        }
        .t-timer{
            width: 7%;
        }
        .t-assignee{
            width: 9%;
            .data {
                max-height: 46px;
                white-space: normal;
            }
        }
        .t-extra{
            width: 2.2%;
        }
        .leads-header {
            padding: 0 8px;
            .t-created {
                width: 15%;
            }
            .t-assignee{
                width: 11.2%;
            }
        }
    }
    .active-filters {
        margin-top: -12px;
    }
    .badge-sm {
        font-size: 75%;
    }
    .not-found {
        min-height: 500px;
        .active-filters {
            max-width: 640px;
        }
    }
</style>